import { Menu } from './menu.model';


export let verticalMenuItems = [
    new Menu(1, 'Dashboard', '/', null, 'dashboard', null, false, 0),
    
    new Menu(2, 'Master', '', null, 'supervisor_account', null, true, 0),
    new Menu(3, 'Users', '/master/users', null, 'supervisor_account', null, false, 2),
    new Menu(203, 'Sequence', '/master/sequence', null, 'supervisor_account', null, false, 2),
    new Menu(4, 'Category', '/master/product-category', null, 'grid_on', null, false, 2),
    new Menu(204, 'WO Type', '/master/wo-type', null, 'work', null, false, 2),
    new Menu(205, 'Billing Milestone', '/master/billing-milestone', null, 'assignment', null, false, 2),
    new Menu(203, 'UOM', '/master/uom', null, 'supervisor_account', null, false, 2),
    new Menu(4, 'Product', '/master/product', null, 'grid_on', null, false, 2),
    new Menu(4, 'Taluka', '/master/taluka', null, 'grid_on', null, false, 2),
    new Menu(203, 'Client', '/master/client', null, 'supervisor_account', null, false, 2),
    new Menu(204, 'Site', '/master/site', null, 'settings_input_antenna', null, false, 2),
    new Menu(203, 'Supplier', '/master/supplier', null, 'supervisor_account', null, false, 2),
    new Menu(206, 'Liability', '/master/liability', null, 'account_balance_wallet', null, false, 2),
    new Menu(202, 'Contractor', '/master/contractor', null, 'supervisor_account', null, false, 2),
    new Menu(202, 'TDS %', '/master/tds', null, 'supervisor_account', null, false, 2),
    new Menu(203, 'Work Type', '/master/work-type', null, 'supervisor_account', null, false, 2),
    new Menu(4, 'Expense Group', '/master/expenseGroup', null, 'supervisor_account', null, false, 2),
    new Menu(4, 'Expense Type', '/master/expense', null, 'supervisor_account', null, false, 2),
    new Menu(4, 'Role', '/master/role', null, 'supervisor_account', null, false, 2),
    new Menu(4, 'Financial Year', '/master/financial', null, 'assignment', null, false, 2),
    new Menu(4, 'Bank', '/master/banks', null, 'supervisor_account', null, false, 2),
    // new Menu(4, 'Bank Account Details', '/master/bank_account_details', null, 'home', null, false, 2),
    new Menu(4, 'Make', '/master/make', null, 'supervisor_account', null, false, 2),
    new Menu(4, 'Tower', '/master/tower', null, 'settings_input_antenna', null, false, 2),
    new Menu(4, 'Terms and conditions ', '/master/terms-and-condition', null, 'assignment', null, false, 2),
    new Menu(4, 'Payment Terms', '/master/payment_terms', null, 'assignment', null, false, 2), 
    new Menu(4, 'Email', '/master/emailData', null, 'assignment', null, false, 2),
    new Menu(3, 'Vendor', '/master/vendor', null, 'supervisor_account', null, false, 2),
    new Menu(2050, 'Project Type', '/master/product-type', null, 'category', null, false, 2),

    new Menu(2052, 'Labor', '/master/labor', null, 'engineering', null, false, 2),
   
    new Menu(2051, 'Tender Estimation Parameter', '/master/tender-estimation-parameter', null, 'tune', null, false, 2),
    

    // new Menu(201, 'Work Order', '/work-order', null, 'fact_check', null, false, 0),
    // new Menu(205, 'Work Order Amendment List', '/work-order/amendment', null, 'edit_note', null, false, 0),
    
    // new Menu(203, 'BOQ', '/boq', null, 'supervisor_account', null, false, 0),
    // new Menu(203, 'BOQ Amendment List', '/boq/amendment', null, 'supervisor_account', null, false, 0),
  // Parent Menu
new Menu(210, 'Project Control Center', '', null, 'folder', null, true, 0),

// Child Menus
new Menu(201, 'Work Order Upload', '/work-order', null, 'fact_check', null, false, 210),

new Menu(205, 'WO Ammend/Edit', '/work-order/amendment', null, 'edit_note', null, false, 210),

new Menu(203, 'Material BOQ Preparation', '/boq', null, 'supervisor_account', null, false, 210),

new Menu(204, 'BOQ Amendment List', '/boq/amendment', null, 'supervisor_account', null, false, 210),

new Menu(206, 'Kick Off Meeting', '/kick-off-meeting', null, 'edit_note', null, false, 210),

new Menu(211, 'DLP', '/dlp', null, 'assignment', null, false, 210),

new Menu(207, 'Project Execution Schedule', '/sitePlanning', null, 'supervisor_account', null, false, 210),

new Menu(208, 'Material Delivery Schedule', '/material-delivery-schedule', null, 'supervisor_account', null, false, 210),

new Menu(209, 'Project Monitoring Dashboard', '/project-monitoring-dashboard', null, 'supervisor_account', null, false, 210),



    
    
    new Menu(203, 'PRN', '/prn', null, 'supervisor_account', null, false, 0),

    new Menu(212, 'Reject PRN', '/reject-prn-entry', null, 'supervisor_account', null, false, 0),

    new Menu(203, 'DPR', '/dpr', null, 'supervisor_account', null, false, 0),
    
    new Menu(221, 'Purchase Order', '/purchase-order', null, 'computer', null, false, 0),
    
    new Menu(221, 'Godown To Godown Transfer', '/godownToGownTransfer', null, 'store', null, false, 0),

    new Menu(203, 'GRN', '/grn', null, 'supervisor_account', null, false, 0),

    new Menu(203, 'Delivery Order', '/delivery-order', null, 'supervisor_account', null, false, 0),

    new Menu(203, 'LOI', '/LOI', null, 'supervisor_account', null, false, 0),

    new Menu(8, 'Sub Contractor', '', null, 'supervisor_account', null, true, 0),
    new Menu(801, 'Contractor WO', '/subContractor', null, 'receipt icon', null, false, 8),
    new Menu(801, 'Issue Material', '/subContractor/site_consumption', null, 'store icon', null, false, 8), 
    new Menu(801, 'Stock Consumption', '/subContractor/sitewise_consumption_stock', null, 'store icon', null, false, 8),
    new Menu(801, 'Contractor Bill entry', '/subContractor/contractor-bill-entry', null, 'store icon', null, false, 8),
    new Menu(801, 'Contractor Payment Workbench', '/subContractor/contractor-payment-workbench', null, 'payments icon', null, false, 8),
    new Menu(801, 'Contractor Advance Payment', '/subContractor/contractor-payment', null, 'store icon', null, false, 8), 
    new Menu(801, 'Contractor Payment Request', '/subContractor/contractor-payment-request', null, 'store icon', null, false, 8),
    new Menu(801, 'Retention Payment', '/subContractor/retention-payment-request', null, 'store icon', null, false, 8),

    new Menu(220, 'Supplier Bill Entry ', '/supplier-bill-entry', null, 'computer', null, false, 0),
    new Menu(225, 'Supplier Payment Workbench', '/supplier-payment-workbench', null, 'payments', null, false, 0),
    new Menu(226, 'Payment Planning Review', '/payment-planning-review', null, 'fact_check', null, false, 0),
    new Menu(227, 'Payment Planning Approval', '/payment-planning-approval', null, 'fact_check', null, false, 0),
    new Menu(228, 'Payment Processing', '/payment-processing', null, 'payments', null, false, 0),

    new Menu(606, 'Client Payment', '', null, 'list', null, true, 0),
    new Menu(456, 'Advance Receipt Entry', '/clientpayment/advancereceiptentry', null, 'store', null, false, 606),
    new Menu(456, 'Receipt Entry', '/clientpayment/receiptentry', null, 'store', null, false, 606),

     new Menu(545, 'Material Return', '', null, 'list', null, true, 0),
     new Menu(456, 'Material Return To Supplier', '/materialReturn/materialReturnToSupplier', null, 'store', null, false, 545), 
      new Menu(456, 'Material Return To Godown', '/materialReturn/materialReturnToGodown', null, 'store', null, false, 545), 
     
    

    //  new Menu(456, 'Material Return To Godown', '/materialReturn/materialReturnToGodown', null, 'store', null, false, 545), 
     new Menu(111, 'Supplier Ledger ', '/ledger/supplier', null, 'store', null, false, 3333), 
      new Menu(222, 'Contractor Ledger ', '/ledger/contracter', null, 'store', null, false, 3333), 
       new Menu(333, 'Client Ledger ', '/ledger/client', null, 'store', null, false, 3333), 
   
    new Menu(203, 'Opening Stock', '/stock', null, 'supervisor_account', null, false, 0),
    new Menu(205, 'Stock Adjustment', '/stock-adjustment', null, 'supervisor_account', null, false, 0),
    new Menu(221, 'Expense Entry', '/expense/expenseEntry', null, 'computer', null, false, 0), 
    new Menu(222, 'Expense Payment', '/expense/payment', null, 'computer', null, false, 0), 
      new Menu(223, 'Expense Checking', '/expense/expenseEntry/checking', null, 'computer', null, false, 0), 
      

     new Menu(9, 'Site Budgeting', '/siteBudgeting', null, 'store', null, false, 0), 

    // new Menu(10, 'Billing', '/billing', null, 'store', null, false, 0), 
    // new Menu(11, 'SITC Work Order', '/billing/work-order', null, 'store', null, false, 10),
    // new Menu(12, 'SITC Invoice', '/billing/invoice', null, 'store', null, false, 10),

    new Menu(11, 'Site Planning', '', null, 'supervisor_account', null, true, 0),
    new Menu(1101, 'Site Planning Stages', '/sitePlanning', null, 'receipt icon', null, false, 11),
    new Menu(1101, 'Site Planning Status', '/sitePlanning/siteStatus', null, 'receipt icon', null, false, 11),


    new Menu(10, 'Invoice', '', null, 'supervisor_account', null, true, 0),
    new Menu(1001, 'Proforma Invoice', '/invoice/proforma', null, 'receipt icon', null, false, 10),
    new Menu(1001, 'TAX Invoice', '/invoice/taxInvoice', null, 'receipt icon', null, false, 10),

     new Menu(544, 'Quotation', '', null, 'list', null, true, 0),
     new Menu(455, 'Quotation Request', '/quotation/request-quotation', null, 'store', null, false, 544), 
     new Menu(455, 'Quotation Entry', '/quotation/quotation-entry', null, 'store', null, false, 544), 
    new Menu(455, 'Quotation Comparison', '/quotation/quotation-comparision-add', null, 'store', null, false, 544), 


    //Report
    new Menu(5, 'Report', '', null, 'list', null, true, 0),
   // new Menu(6, 'Warehouse Stock Grid', '/report/Warehouse-Stock-Grid', null, 'list', null, false, 5),
    new Menu(6, 'Stock Transaction Report', '/report/stock-transaction-Report', null, 'list', null, false, 5),
    new Menu(6, 'BOQ Summary', '/report/boq-summary', null, 'list', null, false, 5),
    new Menu(6, 'BOQ Amendment', '/report/boq-amendmend', null, 'list', null, false, 5),
    new Menu(6, 'BOQ PRN Summary', '/report/boq-prn-summary', null, 'list', null, false, 5),
  //  new Menu(6, 'PRN Summary', '/report/prn-summary', null, 'list', null, false, 5),
    new Menu(6, 'PO Report', '/report/PO-Report', null, 'list', null, false, 5),
    new Menu(6, 'Pending GRN & DC Report', '/report/pending_GRN_DC_Report', null, 'list', null, false, 5),
    new Menu(6, 'Godown Report', '/report/godownStock_report', null, 'list', null, false, 5),
    new Menu(7, 'Purchase Rate Summary', '/report/product_wise_purchase', null, 'list', null, false, 5),
    new Menu(8, 'Expense Ledger', '/report/expense_ledger_component', null, 'list', null, false, 5),
    new Menu(7, 'Supplier Outstanding Summary', '/report/supplier_outstanding_summary', null, 'list', null, false, 5),
    new Menu(7, 'Product Wise Purchase Summary', '/report/product_wise_purchase_summary', null, 'list', null, false, 5),
    
    
    new Menu(7, 'Log', '', null, 'list', null, true, 0),
    new Menu(701, 'Import Log', '/log/import-log', null, 'list', null, false, 7),
    new Menu(702, 'Email Log', '/log/email-log', null, 'list', null, false, 7),

//new Menu(703, 'Site Budgeting', '/siteBudgeting', null, 'store', null, false, 0), 
    // new Menu(704, 'Billing', '', null, 'store', null, true, 0), 
    // new Menu(705, 'SITC Work Order', '/billing/work-order', null, 'store', null, false, 704),
    // new Menu(706, 'SITC Invoice', '/billing/invoice', null, 'store', null, false, 704),
    // new Menu (2, 'Users', '/users', null, 'supervisor_account', null, false, 0),
    //new Menu(3, 'UI Features', null, null, 'computer', null, true, 0),

    //new Menu(4, 'Buttons', '/ui/buttons', null, 'keyboard', null, false, 3),
    //new Menu(5, 'Cards', '/ui/cards', null, 'card_membership', null, false, 3),
    //new Menu(6, 'Lists', '/ui/lists', null, 'list', null, false, 3),
    //new Menu(7, 'Grids', '/ui/grids', null, 'grid_on', null, false, 3),
    //new Menu(8, 'Tabs', '/ui/tabs', null, 'tab', null, false, 3),
    //new Menu(9, 'Expansion Panel', '/ui/expansion-panel', null, 'dns', null, false, 3),
    //new Menu(10, 'Chips', '/ui/chips', null, 'label', null, false, 3),
    //new Menu(11, 'Progress', '/ui/progress', null, 'data_usage', null, false, 3),
    //new Menu(12, 'Dialog', '/ui/dialog', null, 'open_in_new', null, false, 3),
    //new Menu(13, 'Tooltip', '/ui/tooltip', null, 'chat_bubble', null, false, 3),
    //new Menu(14, 'Snackbar', '/ui/snack-bar', null, 'sms', null, false, 3),
    //new Menu(15, 'Dynamic Menu', '/dynamic-menu', null, 'format_list_bulleted', null, false, 0),
    //new Menu(16, 'Mailbox', '/mailbox', null, 'email', null, false, 0),
    //new Menu(17, 'Chat', '/chat', null, 'chat', null, false, 0),
    //new Menu(20, 'Form Controls', null, null, 'dvr', null, true, 0),
    //new Menu(21, 'Autocomplete', '/form-controls/autocomplete', null, 'short_text', null, false, 20),
    //new Menu(22, 'Checkbox', '/form-controls/checkbox', null, 'check_box', null, false, 20),
    //new Menu(23, 'Datepicker', '/form-controls/datepicker', null, 'today', null, false, 20),
    //new Menu(24, 'Form field', '/form-controls/form-field', null, 'view_stream', null, false, 20),
    //new Menu(25, 'Input', '/form-controls/input', null, 'input', null, false, 20),
    //new Menu(26, 'Radio button', '/form-controls/radio-button', null, 'radio_button_checked', null, false, 20),
    //new Menu(27, 'Select', '/form-controls/select', null, 'playlist_add_check', null, false, 20),
    //new Menu(28, 'Slider', '/form-controls/slider', null, 'tune', null, false, 20),
    //new Menu(29, 'Slide toggle', '/form-controls/slide-toggle', null, 'star_half', null, false, 20),
    //new Menu(30, 'Tables', null, null, 'view_module', null, true, 0),
    //new Menu(31, 'Basic', '/tables/basic', null, 'view_column', null, false, 30),
    //new Menu(32, 'Paging', '/tables/paging', null, 'last_page', null, false, 30),
    //new Menu(33, 'Sorting', '/tables/sorting', null, 'sort', null, false, 30),
    //new Menu(34, 'Filtering', '/tables/filtering', null, 'format_line_spacing', null, false, 30),
    //new Menu(35, 'Selecting', '/tables/selecting', null, 'playlist_add_check', null, false, 30),
    //new Menu(36, 'NGX DataTable', '/tables/ngx-table', null, 'view_array', null, false, 30),
    //new Menu(40, 'Pages', null, null, 'library_books', null, true, 0),
    new Menu(43, 'Login', '/login', null, 'exit_to_app', null, false, 40),
    new Menu(44, 'Register', '/register', null, 'person_add', null, false, 40),
    new Menu(45, 'Blank', '/blank', null, 'check_box_outline_blank', null, false, 40),
    new Menu(46, 'Page Not Found', '/pagenotfound', null, 'error_outline', null, false, 40),
    new Menu(47, 'Error', '/error', null, 'warning', null, false, 40),
    new Menu(48, 'Search', '/search', null, 'search', null, false, 40),
    new Menu(49, 'Landing', '/landing', null, 'filter', null, false, 40),
    new Menu(50, 'Profile', null, null, 'person', null, true, 40),
    new Menu(51, 'Projects', '/profile/projects', null, 'note', null, false, 50),
    new Menu(52, 'User Info', '/profile/user-info', null, 'perm_contact_calendar', null, false, 50),
    new Menu(55, 'Schedule', '/schedule', null, 'event_note', null, false, 0),
    //new Menu(66, 'Maps', null, null, 'map', null, true, 0),
    //new Menu(67, 'Google Maps', '/maps/googlemaps', null, 'location_on', null, false, 66),
    //new Menu(68, 'Leaflet Maps', '/maps/leafletmaps', null, 'my_location', null, false, 66),
    //new Menu(70, 'Charts', null, null, 'multiline_chart', null, true, 0),
    //new Menu(71, 'Bar Charts', '/charts/bar', null, 'insert_chart', null, false, 70),
    //new Menu(72, 'Pie Charts', '/charts/pie', null, 'pie_chart', null, false, 70),
    //new Menu(73, 'Line Charts', '/charts/line', null, 'show_chart', null, false, 70),
    //new Menu(74, 'Bubble Charts', '/charts/bubble', null, 'bubble_chart', null, false, 70),
    //new Menu(81, 'Drag & Drop', '/drag-drop', null, 'mouse', null, false, 0),
    //new Menu(85, 'Material Icons', '/icons', null, 'insert_emoticon', null, false, 0),
    //new Menu(140, 'Level 1', null, null, 'more_horiz', null, true, 0),
    //new Menu(141, 'Level 2', null, null, 'folder_open', null, true, 140),
    //new Menu(142, 'Level 3', null, null, 'folder_open', null, true, 141),
    //new Menu(143, 'Level 4', null, null, 'folder_open', null, true, 142),
   // new Menu(144, 'Level 5', null, 'http://themeseason.com', 'link', null, false, 143),
    //new Menu(200, 'External Link', null, 'http://themeseason.com', 'open_in_new', '_blank', false, 0)
]

export const horizontalMenuItems = [
    new Menu(1, 'Dashboard', '/', null, 'dashboard', null, false, 0),
    new Menu(2, 'Users', '/users', null, 'supervisor_account', null, false, 0),
    new Menu(3, 'UI Features', null, null, 'computer', null, true, 0),
    new Menu(4, 'Buttons', '/ui/buttons', null, 'keyboard', null, false, 3),
    new Menu(5, 'Cards', '/ui/cards', null, 'card_membership', null, false, 3),
    new Menu(6, 'Lists', '/ui/lists', null, 'list', null, false, 3),
    new Menu(7, 'Grids', '/ui/grids', null, 'grid_on', null, false, 3),
    new Menu(8, 'Tabs', '/ui/tabs', null, 'tab', null, false, 3),
    new Menu(9, 'Expansion Panel', '/ui/expansion-panel', null, 'dns', null, false, 3),
    new Menu(10, 'Chips', '/ui/chips', null, 'label', null, false, 3),
    new Menu(11, 'Progress', '/ui/progress', null, 'data_usage', null, false, 3),
    new Menu(12, 'Dialog', '/ui/dialog', null, 'open_in_new', null, false, 3),
    new Menu(13, 'Tooltip', '/ui/tooltip', null, 'chat_bubble', null, false, 3),
    new Menu(14, 'Snackbar', '/ui/snack-bar', null, 'sms', null, false, 3),
    new Menu(16, 'Mailbox', '/mailbox', null, 'email', null, false, 40),
    new Menu(17, 'Chat', '/chat', null, 'chat', null, false, 40),
    new Menu(20, 'Form Controls', null, null, 'dvr', null, true, 0),
    new Menu(21, 'Autocomplete', '/form-controls/autocomplete', null, 'short_text', null, false, 20),
    new Menu(22, 'Checkbox', '/form-controls/checkbox', null, 'check_box', null, false, 20),
    new Menu(23, 'Datepicker', '/form-controls/datepicker', null, 'today', null, false, 20),
    new Menu(24, 'Form field', '/form-controls/form-field', null, 'view_stream', null, false, 20),
    new Menu(25, 'Input', '/form-controls/input', null, 'input', null, false, 20),
    new Menu(26, 'Radio button', '/form-controls/radio-button', null, 'radio_button_checked', null, false, 20),
    new Menu(27, 'Select', '/form-controls/select', null, 'playlist_add_check', null, false, 20),
    new Menu(28, 'Slider', '/form-controls/slider', null, 'tune', null, false, 20),
    new Menu(29, 'Slide toggle', '/form-controls/slide-toggle', null, 'star_half', null, false, 20),
    new Menu(30, 'Tables', null, null, 'view_module', null, true, 0),
    new Menu(31, 'Basic', '/tables/basic', null, 'view_column', null, false, 30),
    new Menu(32, 'Paging', '/tables/paging', null, 'last_page', null, false, 30),
    new Menu(33, 'Sorting', '/tables/sorting', null, 'sort', null, false, 30),
    new Menu(34, 'Filtering', '/tables/filtering', null, 'format_line_spacing', null, false, 30),
    new Menu(35, 'Selecting', '/tables/selecting', null, 'playlist_add_check', null, false, 30),
    new Menu(36, 'NGX DataTable', '/tables/ngx-table', null, 'view_array', null, false, 30),
    new Menu(70, 'Charts', null, null, 'multiline_chart', null, true, 0),
    new Menu(71, 'Bar Charts', '/charts/bar', null, 'insert_chart', null, false, 70),
    new Menu(72, 'Pie Charts', '/charts/pie', null, 'pie_chart', null, false, 70),
    new Menu(73, 'Line Charts', '/charts/line', null, 'show_chart', null, false, 70),
    new Menu(74, 'Bubble Charts', '/charts/bubble', null, 'bubble_chart', null, false, 70),
    new Menu(81, 'Drag & Drop', '/drag-drop', null, 'mouse', null, false, 3),
    new Menu(85, 'Material Icons', '/icons', null, 'insert_emoticon', null, false, 3),
    new Menu(40, 'Pages', null, null, 'library_books', null, true, 0),
    new Menu(43, 'Login', '/login', null, 'exit_to_app', null, false, 40),
    new Menu(44, 'Register', '/register', null, 'person_add', null, false, 40),
    new Menu(45, 'Blank', '/blank', null, 'check_box_outline_blank', null, false, 40),
    new Menu(46, 'Page Not Found', '/pagenotfound', null, 'error_outline', null, false, 40),
    new Menu(47, 'Error', '/error', null, 'warning', null, false, 40),
    new Menu(48, 'Search', '/search', null, 'search', null, false, 40),
    new Menu(49, 'Landing', '/landing', null, 'filter', null, false, 40),
    new Menu(50, 'Profile', null, null, 'person', null, true, 40),
    new Menu(51, 'Projects', '/profile/projects', null, 'note', null, false, 50),
    new Menu(52, 'User Info', '/profile/user-info', null, 'perm_contact_calendar', null, false, 50),
    new Menu(55, 'Schedule', '/schedule', null, 'event_note', null, false, 40),
    new Menu(200, 'External Link', null, 'http://themeseason.com', 'open_in_new', '_blank', false, 40),
    new Menu(66, 'Maps', null, null, 'map', null, true, 0),
    new Menu(67, 'Google', '/maps/googlemaps', null, 'location_on', null, false, 66),
    new Menu(68, 'Leaflet', '/maps/leafletmaps', null, 'my_location', null, false, 66),
]